import QRCode from 'qrcode'
import { createCanvas } from 'canvas'

export async function getLegnaQrCodeUrl (width, qrContent) {
  const version = getQrVersion(qrContent.length)

  const canvas = createCanvas(width, width)

  QRCode.toCanvas(
    canvas,
    qrContent,
    {
      errorCorrectionLevel: 'M',
      margin: 1,
      width: width,
      version: version
    }
  )

  return canvas.toDataURL('image/svg')
}

// qr code density levels are called versions. there is more that goes into calculating the version
// of the qr code other than the number of characters,
// so we are forcing the version based on the length of the string itself
// https://www.qrcode.com/en/about/version.html

function getQrVersion (length) {
  if (length < 8) {
    return 1
  } else if (length < 15) {
    return 2
  } else if (length < 25) {
    return 3
  } else if (length < 35) {
    return 4
  } else if (length < 45) {
    return 5
  } else if (length < 55) {
    return 6
  } else if (length < 65) {
    return 7
  } else if (length < 75) {
    return 8
  } else if (length < 85) {
    return 9
  } else if (length < 100) {
    return 10
  } else if (length < 110) {
    return 11
  } else if (length < 120) {
    return 12
  } else if (length < 130) {
    return 13
  } else if (length < 140) {
    return 14
  } else if (length < 150) {
    return 15
  } else if (length < 160) {
    return 16
  } else if (length < 170) {
    return 17
  } else if (length < 180) {
    return 18
  } else if (length < 190) {
    return 19
  } else if (length < 200) {
    return 20
  } else {
    throw new Error('legnaQrCode does not support strings larger than 200 characters')
  }
}
